import { cn } from "@/lib/utils";

/**
 * Status chips that filter a list page. One chip = one status: its count, and (optionally) its amount.
 * Same props as the old tab strip, so every page that used it keeps working:
 *   tabs: [{ key, label, count?, sub?, tone? }]   tone: "orange" | "red" | "green" tints the count only.
 */
const TONE = {
  orange: "text-amber-700 dark:text-amber-400",
  red: "text-rose-600 dark:text-rose-400",
  green: "text-emerald-700 dark:text-emerald-400",
};

export function TabFilter({ tabs = [], active, onChange }) {
  return (
    <div className="flex flex-wrap gap-2" role="tablist" data-testid="tab-filter">
      {tabs.map((t) => {
        const on = active === t.key;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(t.key)}
            data-testid={`tab-filter-${t.key?.toLowerCase()}`}
            className={cn(
              "min-w-[7rem] max-w-[14rem] flex-1 basis-28 rounded-md border px-3 py-2 text-left transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
              on ? "border-primary bg-primary/5" : "border-border bg-card hover:bg-muted/50"
            )}
          >
            <span className="block truncate text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{t.label}</span>
            {t.count != null && (
              <span className={cn("mt-0.5 block text-lg font-semibold tabular-nums leading-tight", TONE[t.tone] || "text-foreground")}>{t.count}</span>
            )}
            {t.sub && <span className="block truncate text-xs tabular-nums text-muted-foreground">{t.sub}</span>}
          </button>
        );
      })}
    </div>
  );
}
